import { PendingChange } from '@/shared/config';

export const splitPendingChanges = (pendingChanges: PendingChange[]) => {
  return pendingChanges.reduce(
    (acc, item) => {
      const copiedItem = { ...item };

      if (item.newNumber === -1) {
        return {
          ...acc,
          removes: [...acc.removes, copiedItem],
        };
      }

      return {
        ...acc,
        changes: [...acc.changes, copiedItem],
      };
    },
    { removes: [], changes: [] } as {
      removes: PendingChange[];
      changes: PendingChange[];
    },
  );
};
